import { LBButton, LBDialogFooter } from '@linearb/buzz';

const DeleteFooter = ({ onDelete, variant = 'default', disabled = false }) => {
  return (
    <LBDialogFooter className='mt-8'>
      <LBButton variant={variant} onClick={onDelete} disabled={disabled}>
        Delete Integration
      </LBButton>
    </LBDialogFooter>
  );
};

export default DeleteFooter;
